exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".table-column-config-dialog .el-dialog__body{padding-top:12px;padding-bottom:12px}", "", {"version":3,"sources":["/workspace/core/components/TableColumnConfigDialog.vue"],"names":[],"mappings":"AACA,6CAA6C,iBAAiB,mBAAmB,CAChF","file":"TableColumnConfigDialog.vue","sourcesContent":["\n.table-column-config-dialog .el-dialog__body{padding-top:12px;padding-bottom:12px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f7827dc","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./core/components/TableColumnConfigDialog.vue
// module id = 1804
// module chunks = 2 127 128 129